import { PlOption } from 'pl-core-services';

export const PL_FREQUENCY_OPTIONS: PlOption[] = [
  { value: '1', label: '1 time' },
  { value: '2', label: '2 times' },
  { value: '3', label: '3 times' },
  { value: '4', label: '4 times' },
  { value: '5', label: '5 times' },
  { value: '6', label: '6 times' },
  { value: '7', label: '7 times' },
  { value: '8', label: '8 times' },
];
